import { StoryBoard } from 'services/storyboard.service';
import { useAppDispatch } from 'store/store-hooks';
import { EMPTY_CELL, handleClips } from 'components/app/editor/_mediator/editor.slice';
import { SbPosition } from 'components/app/editor/_mediator/editor-controls.slice';

export const useClipsDnd = () => {
  const dispatch = useAppDispatch();
  return (origin: SbPosition, target: SbPosition, len: number, sb: StoryBoard) => {
    const activeClip = sb[origin.track][origin.cell];
    const selectedClips = Array.from({ length: len }, (_, i) => i)
      .map((i) => sb[origin.track][origin.cell + i])
      .filter((el) => el !== null) as ClipId[];
    dispatch(
      handleClips({
        data: { storyBoard: len === 1 ? swapClips(origin, target, sb) : moveClips(origin, target, len, sb) },
        backupParams: {
          title: 'DnD Clip',
          activeClip: [activeClip, activeClip],
          selectedClips: [selectedClips, selectedClips],
        },
      })
    );
  };
};

/* H E L P E R S */

const swapClips = (origin: SbPosition, target: SbPosition, sb: StoryBoard) => {
  const _sb = copySb(origin, target, sb);
  const originClip = _sb[origin.track]![origin.cell];
  const targetClip = _sb[target.track]![target.cell];
  _sb[origin.track]![origin.cell] = targetClip;
  _sb[target.track]![target.cell] = originClip;
  return _sb;
};

const moveClips = (origin: SbPosition, target: SbPosition, len: number, sb: StoryBoard) => {
  const _sb = copySb(origin, target, sb);
  const increments = Array.from({ length: len }, (_, i) => i);
  increments.forEach((incr) => (_sb[origin.track]![origin.cell + incr] = EMPTY_CELL));
  increments.forEach((incr) => (_sb[target.track]![target.cell + incr] = sb[origin.track]![origin.cell + incr]));
  return _sb;
};

const copySb = (origin: SbPosition, target: SbPosition, sb: StoryBoard): Partial<StoryBoard> => {
  const res: Partial<StoryBoard> = {};
  res[origin.track] = [...sb[origin.track]];
  if (origin.track !== target.track) res[target.track] = [...sb[target.track]];
  return res;
};
